import $ from "jquery";
import React from "react";
import { Link } from "react-router-dom";
import Loader from "../../component/common/Loader";
import Shimmer from "../../component/common/Shimmer";
import AddComment from "../../component/file/AddComment";
import CONSTANT from "../../constant";
import "./../../assets/css/CommentModel.css";
import logo from "./../../assets/images/logo.png";
import * as pdfjsLib from 'pdfjs-dist';

import {
  createPrintLog,
  getFileDetail,
  getFileTimeLine,
  reCallFile,
  reOpenFile,
} from "../../actions/FileAction";

import { CommandBarButton } from "@fluentui/react/lib/Button";
import Swal from "sweetalert2";
import { fileOtpVerify, FileSendOpt } from "../../actions/AuthAction";
import {
  addComment,
  getCommentList,
  uploadAttachment,
} from "../../actions/CommentAction";
import CommentModel from "../../component/commentmodel/CommentModel";
import { Accordion } from "../../component/file/Accrodian";
import FileTimeline from "../../component/file/FileTimeline";
import { getCookie, getDateParts, getStorage, setCookie } from "../../utils";
import ParkedFileReferenceDetails from "./ParkedFileReferenceDetails";
import { toast } from "react-toastify";

// Set PDF.js worker
pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

class ComponentName extends React.Component<any, any> {
  canvasRef: React.RefObject<HTMLCanvasElement>;
  
  constructor(props: any) {
    super(props);
    this.canvasRef = React.createRef();
    this.state = {
      code: props.match.params.code,
      ud: getCookie(CONSTANT.cookie.userDetail),
      permissions: getStorage(CONSTANT.cookie.permissions),
      detail: undefined,
      comments: undefined,
      showAddComment: false,
      showAddCommentLoder: false,
      showLoader: false,
      showTimeLineModal: false,
      timeLineDetails: null,
      visibleParkedFile: false,
      attachedParkedFiles: "",
      isOpen: false,
      printReason: "",
      otherPrintReason: "",
      
      // PDF Viewer state
      showPDFViewer: false,
      pdfUrl: "",
      pdf: null,
      currentPage: 1,
      totalPages: 0,
      pdfLoading: false,
    };
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    window.onload = function () {
      window.scrollTo(0, document.body.scrollHeight);
    };
    document.title = CONSTANT.pageTitle.fileDetail;
    const { code } = this.state;

    getCommentList(code).then((res: any) => {
      this.setState({ comments: res.result });
    });

    getFileDetail(code).then((res: any) => {
      if (res.error) {
        alert(res.error);
      } else {
        const { ud, permissions } = this.state;
        const { cc, pendingWith } = res?.result;
        const detailData = res?.result;

        const isPending = pendingWith.some((i: any) => i.userCode === ud.code);
        const isAdmin = permissions.includes(
          CONSTANT.static.permissions.fileAdminAccess
        );
        const isCC = cc.some((i: any) => i.code === ud.code);
        const isCreatorOfClosed =
          detailData?.isClosed === true && detailData?.createdBy === ud?.code;

        const hasAccess = isPending || isAdmin || isCC || isCreatorOfClosed;

        if (hasAccess) {
          this.setState({ detail: detailData });
          getCommentList(code).then((r: any) => {
            this.setState({ comments: r?.result });
            window.scrollTo(0, document.body.scrollHeight);
          });
        } else {
          alert("You are not authorized to view the content of the file");
          this.setState({ comments: [] });
        }
      }
    });
  }

  // PDF.js Methods
 loadPDF = async (url: string) => {
  try {
    const initialPage = this.getInitialPageFromUrl(url);

    this.setState({ pdfLoading: true });

    const loadingTask = pdfjsLib.getDocument(url.split('#')[0]);
    const pdfDoc = await loadingTask.promise;

    this.setState(
      {
        pdf: pdfDoc,
        totalPages: pdfDoc.numPages,
        currentPage: Math.min(initialPage, pdfDoc.numPages),
        pdfLoading: false,
      },
      () => {
        this.renderPage(this.state.currentPage);
      }
    );
  } catch (error) {
    console.error("Error loading PDF:", error);
    this.setState({ pdfLoading: false });
    toast.error("Failed to load PDF.");
  }
};


  renderPage = async (pageNumber: number) => {
    const { pdf } = this.state;
    if (!pdf || !this.canvasRef.current) return;

    try {
      const page = await pdf.getPage(pageNumber);
      const canvas = this.canvasRef.current;
      const context = canvas.getContext('2d');
      
      const viewport = page.getViewport({ scale: 1.5 });
      canvas.height = viewport.height;
      canvas.width = viewport.width;

      await page.render({
        canvasContext: context!,
        viewport: viewport,
      }).promise;
    } catch (error) {
      console.error('Error rendering page:', error);
    }
  };

  nextPage = () => {
    const { currentPage, totalPages } = this.state;
    if (currentPage < totalPages) {
      const newPage = currentPage + 1;
      this.setState({ currentPage: newPage }, () => {
        this.renderPage(newPage);
      });
    }
  };

  prevPage = () => {
    const { currentPage } = this.state;
    if (currentPage > 1) {
      const newPage = currentPage - 1;
      this.setState({ currentPage: newPage }, () => {
        this.renderPage(newPage);
      });
    }
  };

  closePDFViewer = () => {
    this.setState({
      showPDFViewer: false,
      pdfUrl: "",
      pdf: null,
      currentPage: 1,
      totalPages: 0,
    });
  };

  getInitialPageFromUrl = (url: string) => {
  const match = url.match(/#page=(\d+)/);
  return match ? parseInt(match[1], 10) : 1;
};


  // Handle attachment clicks
 handleAttachmentClick = (url: string, fileName: string) => {
  // remove hash & query params
  const cleanUrl = url.split('#')[0].split('?')[0];
  const extension = cleanUrl.split('.').pop()?.toLowerCase();

  if (extension === 'pdf') {
this.setState(
  {
    showPDFViewer: true,
    pdfUrl: cleanUrl, // ✅ keep clean (no #page)
  },
  () => this.loadPDF(url) // ✅ MUST pass original URL with #page
);


  } else {
    window.open(url, '_blank');
  }
};


  // Function to intercept link clicks
 handleClick(e: React.MouseEvent<HTMLDivElement>) {
  const target = e.target as HTMLElement;

  if (target.tagName !== 'A') return;

  const anchor = target as HTMLAnchorElement;
  const url = anchor.href;

  // stop browser immediately
  e.preventDefault();
  e.stopPropagation();

  const fileName = url.split('/').pop() || 'file';
  this.handleAttachmentClick(url, fileName);
}


  openModal = () => {
    this.setState({ isOpen: true });
  };

  handleOtherPrintReasonChange = (e: any) => {
    this.setState({ otherPrintReason: e.target.value });
  };

  handlePrintReasonChange = (event: any) => {
    this.setState({ printReason: event.target.value });
  };

  closeModal = () => {
    this.setState({ isOpen: false });
  };

  render() {
    const { show } = this.props;
    if (show) {
      return true;
    }

    const { detail, comments } = this.state;
    const { showAddComment, showLoader, ud, showAddCommentLoder } = this.state;

    let showAddCommentButton = false;

    if (detail) {
      showAddCommentButton = detail.pendingWith.find(
        (item: any) => item.userCode === ud.code
      );
      showAddCommentButton =
        showAddCommentButton && detail.detail.isClosed === false;
    }

    return (
      <>
        <div>
          {this.state.isOpen && (
            <div className="modal-overlay">
              <div className="popup-boxx">
                <h2>Enter the print reason</h2>
                <select
                  name="document_reasons"
                  className="form-select my-3 p-2 rounded"
                  id="document-reasons"
                  value={this.state.printReason}
                  onChange={this.handlePrintReasonChange}
                >
                  <option value="">-- Select a reason --</option>
                  <option value="Dispatching physical documents">
                    Dispatching physical documents
                  </option>
                  <option value="Creating physical records for archival">
                    Creating physical records for archival
                  </option>
                  <option value="External stakeholder requirements">
                    External stakeholder requirements
                  </option>
                  <option value="Offline access and review">
                    Offline access and review
                  </option>
                  <option value="Backups and disaster recovery">
                    Backups and disaster recovery
                  </option>
                  <option value="For official approvals (in some cases)">
                    For official approvals (in some cases)
                  </option>
                  <option value="OTHER">OTHER</option>
                </select>

                {this.state.printReason === "OTHER" && (
                  <textarea
                    rows={3}
                    cols={10}
                    className="my-3 p-2 rounded"
                    value={this.state.otherPrintReason}
                    onChange={this.handleOtherPrintReasonChange}
                    placeholder="Please specify your reason..."
                  ></textarea>
                )}

                <div className="button-groupp">
                  <button className="cancel-btn" onClick={this.closeModal}>
                    Cancel
                  </button>
                  <button className="ok-btn" onClick={this.handlePrintLog}>
                    OK
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="container-fluid" id="modbox00">
          <div className="row">
            <div className="col-md-12">
              <div className="card homedob p-1 px-3">
                <div className="row align-items-center my-2">
                  <div className="col-md-8">
                    <h1 className="page-title mb-0"> File detail</h1>
                  </div>
                  <div className="col-md-4">
                    {/* <Link
                      to={CONSTANT.component.userFileList.url}
                      className="btn btn-sm btn-link float-right"
                    >
                      Go Back
                    </Link> */}
                    <button
                      className="btn btn-sm btn-link float-right"
                      onClick={() => {
                        if (this.props.history.length > 1) {
                          this.props.history.goBack();
                        } else {
                          this.props.history.push(CONSTANT.component.userFileList.url);
                        }
                      }}
                    >
                      Go Back
                    </button>

                    <button
                      onClick={this.openModal}
                      className="btn btn-sm btn-link float-right"
                    >
                      <i className="fa fa-print" /> Print
                    </button>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  {detail === undefined && <Shimmer />}
                  {detail !== undefined && this.renderDetail()}
                  {detail !== undefined &&
                    comments !== undefined &&
                    this.renderComments()}
                  {detail !== undefined && this.renderFileClosedSection()}
                  {detail !== undefined &&
                    !detail?.detail.isClosed &&
                    this.renderRecallFileSection()}
                </div>
              </div>
            </div>
          </div>
          {showLoader && <Loader />}
          {showAddCommentLoder && <Loader />}

          {showAddCommentButton && (
            <React.Fragment>
              <div className="comment-button">
                <button
                  className="bg-primary text-white"
                  onClick={() => {
                    this.toggleAddComment();
                    const modal = document.getElementById("myModal");
                    if (modal) {
                      modal.style.display = "block";
                    }
                  }}
                  style={{
                    width: "150px",
                    height: "30px",
                    display: "inline-flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "10px",
                    background: "radial-gradient(#1c5899, #01458e)",
                  }}
                >
                  Add Comment
                </button>
                <button
                  className="bg-primary text-white ml-2"
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                  style={{
                    width: "30px",
                    height: "30px",
                    display: "inline-flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "50%",
                    background: "radial-gradient(#1c5899, #01458e)",
                  }}
                >
                  <i className="fa fa-long-arrow-up"></i>
                </button>
              </div>
            </React.Fragment>
          )}
        </div>

        {showAddComment && (
          <CommentModel
            title="Add comment"
            backdrop="static"
            className="modal-lg"
            toggleModal={this.toggleAddComment2}
          >
            <AddComment
              nextlevelReviewers={detail.nextlevelReviewers}
              pendingWith={detail.pendingWith}
              detail={detail.detail}
              approver={detail.approvers}
              onSubmit={this.onAddComment}
              toggleModal={this.toggleAddComment2}
            />
          </CommentModel>
        )}
      </>
    );
  }

  renderDetail = () => {
    const { detail, showPDFViewer, pdfUrl, currentPage, totalPages, pdfLoading } = this.state;
    const fileDated = getDateParts(detail?.detail.dated);
    const createdOn = getDateParts(detail?.detail.createdOn);
    const { referenceFiles, parkedFileAttached } = detail.detail;

    let parkedFileList = JSON.parse(parkedFileAttached);

    return (
      <React.Fragment>
        <div className="card homedob p-4 mb-4">
          <div
            className="card main-file mb-3"
            id={`file-${detail?.detail.code}`}
          >
            <div className="card-body">
              <div className="row">
                <div className="col-md-12 text-center pb-4">
                  <img
                    src={logo}
                    alt="logo"
                    className="paglogo"
                    style={{ maxWidth: "400px" }}
                  />
                </div>
              </div>
              <div className="row">
                <div className={showPDFViewer ? "col-md-6" : "col-md-12"}>
                  <div
                    className={
                      detail?.detail?.sheetType === "green"
                        ? "sheet-colur-green"
                        : "sheet-colur-yellow"
                    }
                  >
                    <div className="col-md-12 text-right pb-3">(1)</div>
                    <div className="mb-2">
                      <strong>
                        Comp. No.: {detail?.detail?.code}
                        <span className="float-right">
                          {`${fileDated.date} ${fileDated.monthName} ${fileDated.year}`}
                        </span>
                      </strong>
                    </div>
                    <div className="mb-2">
                      <strong>No:</strong> {detail?.detail?.fileNumber}
                      <span className="float-right">
                        {`${fileDated.date} ${fileDated.monthName} ${fileDated.year}`}
                      </span>
                    </div>

                    <div className="mb-1">
                      <strong className="">
                        Subject: {detail?.detail?.subject}
                      </strong>
                    </div>
                    
                    <div className="FileDetailPage"
                      onClickCapture={this.handleClick}
                      dangerouslySetInnerHTML={{
                        __html: detail?.detail?.body
                        ?.replace(/&nbsp;/g, " ")
                        .replace(
                            /(\S+)(\s+)(\d{2}\.\d{2}\.\d{4})/,
                            "$1 |$2$3"
                          )
                        .replace(/(?:\r\n|\r|\n)/g, "<br/>"),
                      }}
                    />
                  </div>
                </div>

                {/* PDF.js Viewer */}
                {showPDFViewer && (
                  <div className="col-md-6 no-print">
                    <div className="d-flex justify-content-between align-items-center mb-2 p-2 bg-light rounded-top">
                      <small className="text-muted">
                        <i className="fa fa-file-pdf-o mr-1"></i> 
                        PDF Viewer {totalPages > 0 && `- Page ${currentPage} of ${totalPages}`}
                      </small>
                      <div>
                        {totalPages > 0 && (
                          <>
                            <button
                              onClick={this.prevPage}
                              disabled={currentPage <= 1}
                              className="btn btn-sm btn-secondary mr-1"
                              title="Previous Page"
                            >
                              <i className="fa fa-chevron-left"></i>
                            </button>
                            <button
                              onClick={this.nextPage}
                              disabled={currentPage >= totalPages}
                              className="btn btn-sm btn-secondary mr-2"
                              title="Next Page"
                            >
                              <i className="fa fa-chevron-right"></i>
                            </button>
                          </>
                        )}
                        <a
                          href={pdfUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-info btn-sm mr-2"
                          title="Open in New Tab"
                        >
                          <i className="fa fa-external-link mr-1"></i> Open
                        </a>
                        <button
                          onClick={this.closePDFViewer}
                          className="btn btn-danger btn-sm"
                          title="Close Viewer"
                        >
                          <i className="fa fa-times mr-1"></i> Close
                        </button>
                      </div>
                    </div>

                    {pdfLoading ? (
                      <div className="text-center p-5" style={{ height: '500px', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #dee2e6' }}>
                        <div>
                          <i className="fa fa-spinner fa-spin fa-3x text-primary"></i>
                          <p className="mt-3">Loading PDF...</p>
                        </div>
                      </div>
                    ) : (
                      <div style={{ maxHeight: '500px', overflow: 'auto', border: '1px solid #dee2e6' }}>
                        <canvas 
                          ref={this.canvasRef} 
                          style={{ width: '100%', display: 'block' }}
                        />
                      </div>
                    )}
                  </div>
                )}

                <div className="col-md-12 mt-3 text-right">
                  <span className="fs-12">
                    <span className="font-semibold">{detail.detail.employeeName}</span>
                    <span className="px-1">|</span>
                    {detail.detail.createdByDesignation}
                    <span className="px-1">|</span>
                    {`${createdOn.date} ${createdOn.monthName} ${createdOn.year} ${createdOn.hour}:${createdOn.minute}:${createdOn.seconds} ${createdOn.amOrpm}`}
                  </span>
                </div>
              </div>
            </div>

            {/* file attachment section  */}
            <div>
              {detail.attachments.length > 0 && (
                <div className="card-footer no-print printFile">
                  <div className="row">
                    <div className="col-md-12 no-print">
                      <span className="mr-3">Attachment(s)</span>

                      {detail.attachments
                        .filter((i: any) => i.commentCode === null)
                        .map((item: any, index: number) => {
                          const downloadURL =
                            `${process.env.REACT_APP_BASE_URL}attachment/${item.fileCode}/${item.fileName}`.replace(
                              "v1/",
                              ""
                            );
                          return (
                            <div
                              key={index}
                              className="d-inline-flex align-items-center mr-2 mb-2"
                            >
                              <span
                                onClick={() =>
                                  this.handleAttachmentClick(
                                    downloadURL,
                                    item.originalFileName
                                  )
                                }
                                className="badge badge-info mr-1 p-2"
                                style={{ cursor: "pointer" }}
                                title="Click to view in preview"
                              >
                                <i className="fa fa-eye mr-1" />
                                {item.originalFileName}
                              </span>
                              <a
                                href={downloadURL}
                                target="_blank"
                                className="badge badge-primary p-2"
                                title="Download"
                                onClick={(e) => e.stopPropagation()}
                              >
                                <i className="fa fa-download" />
                              </a>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Reference Links Section */}
<div>
  {(() => {
    const bodyHTML = detail?.detail?.body || '';
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = bodyHTML;
    const links = Array.from(tempDiv.querySelectorAll('a'));
    
    return links.length > 0 && (
      <div className="card-footer no-print printFile">
        <div className="row">
          <div className="col-md-12 no-print">
            <span className="mr-3">Reference Link(s)</span>

            {links.map((link: any, index: number) => {
              const linkURL = link.href;
              const linkText = link.textContent || link.innerText || 'Link';
              const fileName = linkURL.split('/').pop() || linkURL;
              
              return (
                <div
                  key={index}
                  className="d-inline-flex align-items-center mr-2 mb-2"
                >
                  <span
                    onClick={() => this.handleAttachmentClick(linkURL, fileName)}
                    className="badge badge-info mr-1 p-2"
                    style={{ cursor: "pointer" }}
                    title="Click to view in preview"
                  >
                    <i className="fa fa-eye mr-1" />
                    {linkText}
                  </span>
                  <a
                    href={linkURL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="badge badge-primary p-2"
                    title="Open in new tab"
                    onClick={(e:any) => e.stopPropagation()}
                  >
                    <i className="fa fa-external-link" />
                  </a>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  })()}
</div>

            {/*  file attachment section */}
            {referenceFiles && referenceFiles.length > 0 && (
              <div className="card-footer no-print printFile">
                <div className="row">
                  <div className="col-md-12 no-print">
                    <span className="mr-3">Reference File(s)</span>
                    {referenceFiles.map((item: any, index: number) => {
                      const downloadURL =
                        `${process.env.REACT_APP_BASE_URL}attachment/${item.fileCode}/${item.fileName}`.replace(
                          "v1/",
                          ""
                        );

                      return (
                        <a
                          href={downloadURL}
                          target="_blank"
                          key={index}
                          className="badge badge-primary mr-1 p-2"
                        >
                          <i className="fa fa-arrow-circle-o-down" />
                          {item.originalFileName}
                        </a>
                      );
                    })}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {detail !== undefined &&
          (detail.department.length > 0 ||
            detail.detail.financialImplication ||
            detail.approvers.length > 0) && (
            <div className="card homedob p-4 mb-4">
              <div className="card alert-info mb-3 additional_info">
                <div className="card-header add-info fw-bold fs-4">
                  Additional Info
                </div>
                <div className="card-body bgbody">
                  <div className="row">
                    {detail.department.length > 0 && (
                      <div className="col">
                        <b>Departments Sequence</b>
                        <br />
                        {detail.department.map(function (
                          dept: any,
                          index: number
                        ) {
                          return (
                            <span
                              key={index}
                              className="badge badge-primary mr-1"
                            >
                              {dept.name}
                            </span>
                          );
                        })}
                      </div>
                    )}
                    {detail.detail.financialImplication && (
                      <div className="col">
                        <b>Financial implication </b>
                        <br />
                        {`${CONSTANT.static.currencySymbol} ${parseFloat(
                          detail.detail.financialImplication
                        ).toLocaleString(CONSTANT.static.locale)}`}
                      </div>
                    )}
                    {detail.approvers.length > 0 && (
                      <div className="col">
                        <b>Approver</b>
                        <br />
                        {detail.approvers
                          .map((item: any) => item.name)
                          .join(", ")}
                      </div>
                    )}

                    {
                      <div className="col">
                        <CommandBarButton
                          onClick={() =>
                            this.setState({ showTimeLineModal: true })
                          }
                          style={{ backgroundColor: "transparent" }}
                          text="View Timeline"
                        />
                      </div>
                    }

                    {
                      <div className="col">
                        <CommandBarButton
                          onClick={() => {
                            //  this.setState({...this.state ,   visibleParkedFile: true })
                          }}
                          style={{ backgroundColor: "transparent" }}
                          text="Attached Parked File "
                        />{" "}
                        :{" "}
                        <span>
                          {" "}
                          {parkedFileAttached != null
                            ? JSON.parse(parkedFileAttached).length
                            : 0}{" "}
                        </span>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          )}

        <FileTimeline
          isOpen={this.state.showTimeLineModal}
          onDismiss={() => this.setState({ showTimeLineModal: false })}
          fetchData={this.fetchFileTimeLine}
          timeLineDetails={this.state.timeLineDetails}
        />

        {parkedFileList &&
          parkedFileList.length > 0 &&
          parkedFileList.map((ele: any) => {
            return (
              <Accordion header={`${ele.fileNumber} ( ${ele.subject} ) `}>
                <ParkedFileReferenceDetails fileCode={ele.code} />
              </Accordion>
            );
          })}

        {/* <AttachedParkedFile 
                  isOpen={ this.state.visibleParkedFile }
                  onDismiss={() => this.setState({...this.state , visibleParkedFile : false }) }
                  fetchData={false}
                  fileCodes= {JSON.parse(parkedFileAttached)}
                  // timeLineDetails={this.state.timeLineDetails}
                /> */}
      </React.Fragment>
    );
  };

  renderFileClosedSection = () => {
    const { detail } = this.state;
    const closedOnDt = getDateParts(detail.detail.closedOn);
    const showDiv = detail.detail.isClosed;

    return (
      showDiv && (
        <div className="ms-MessageBar ms-MessageBar--warning">
          <div className="ms-MessageBar-content">
            <div className="ms-MessageBar-icon">
              <i className="ms-Icon ms-Icon--Info"></i>
            </div>
            <div className="ms-MessageBar-text ">
              <p className="font-bold text-success">
                {" "}
                {`files have been parked  on ${closedOnDt.date} ${closedOnDt.monthName} ${closedOnDt.year}`}{" "}
                <button className="text-warning" onClick={this.onRecallFile}>
                  Click here to re-call this file
                </button>
              </p>
            </div>
          </div>
        </div>
      )
    );
  };

  renderComments = () => {
    const { comments, detail, ud, permissions } = this.state;
    const isParked = detail?.detail?.isClosed === true;
    // const isParkedByMe = detail?.detail?.closedBy === ud.code;
    const isCreator = detail?.detail?.createdBy === ud.code;



    const canReadComments =(
      detail.pendingWith.find((item: any) => item.userCode === ud.code) ||
      detail.cc.some((item: any) => item.code === ud.code) ||
      // detail.detail.closedBy === ud.code ||
      // detail.detail.modifiedBy === ud.code ||
      permissions.indexOf(CONSTANT.static.permissions.fileAdminAccess) > -1
    )&&
  (!isParked || isCreator);

    const renderComments =
      comments &&
      comments.length > 0 &&
      comments.map((item: any, index: number) => {
        const commentDt = getDateParts(item.createdOn);
        const commAttachment = detail.attachments.filter(
          (i: any) => i.commentCode === item.code
        );
        return (
          <div className="card comment-file mb-3" key={index}>
            <div className="card-body">
              <div className="row">
                <div className="col-md-12 text-center">
                  <div>
                    <span>({index + 2})</span>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <strong>{item.notingName}</strong>
                </div>

                {item.comment && (
                  <div className="col-md-12 text-justify">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.comment.replace(/(?:\r\n|\r|\n)/g, "<br>"),
                      }}
                    />
                  </div>
                )}
              </div>
              <div className="row mt-3">
                <div className="col-md-6"></div>
                <div className="col-md-6 text-right">
                  <span className="fs-12">
                    <span className="font-semibold">{item.employeeName}</span>
                    <span className="px-1">|</span>
                    {item.createdByDesignation}
                    <span className="px-1">|</span>
                    {`${commentDt.date} ${commentDt.monthName} ${commentDt.year} ${commentDt.hour}:${commentDt.minute}:${commentDt.seconds} ${commentDt.amOrpm}`}
                    {item?.approverName && (
                      <>
                        <br />
                        <span className="font-semibold">Approver:</span> {item.approverName}
                      </>
                    )}

                    {item?.financialImplication && (
                      <>
                        <span className="px-1">|</span>
                        <span className="font-semibold">Financial implication:</span> {item.financialImplication}
                      </>
                    )}
                  </span>
                </div>
              </div>
            </div>

            {commAttachment.length > 0 && (
              <div className="card-footer no-print">
                <div className="row">
                  <div className="col-md-12">
                    <span className="mr-3">Attachment(s)</span>

                    {commAttachment.map(function (
                      attachment: any,
                      index2: number
                    ) {
                      const downloadURL =
                        `${process.env.REACT_APP_BASE_URL}attachment/${attachment.fileCode}/${attachment.commentCode}/${attachment.fileName}`.replace(
                          "v1/",
                          ""
                        );
                      return (
                        <>
                          <a
                            href={downloadURL}
                            target="_blank"
                            key={index2}
                            className="badge badge-primary mr-1 p-2 mb-1"
                          >
                            <i className="fa fa-arrow-circle-o-down" />
                            {attachment.originalFileName}
                          </a>
                        </>
                        // <a href={downloadURL} target="_blank" key={index2} className="badge badge-primary mr-1 p-2"><i className="fa fa-arrow-circle-o-down" />{attachment.fileName}</a>
                      );
                    })}
                  </div>
                </div>
              </div>
            )}
          </div>
        );
      });

    if (canReadComments) {
      return renderComments;
    } else {
      return (
        <div className="card comment-file mb-3">
          <div className="card-body text-center">
            Comments are only visible to the marked person.
          </div>
        </div>
      );
    }
  };

  fetchFileTimeLine = async () => {
    const { detail } = this.state;
    const fileCode = detail.detail.code;
    const { result } = await getFileTimeLine(fileCode);
    let timeline = result;
    timeline.level = detail.detail.level;
    this.setState({ timeLineDetails: timeline });
  };

  renderRecallFileSection = () => {
    const { detail, ud } = this.state;
    const closedOnDt = getDateParts(detail.detail.modifiedOn);
    const showDiv =
      (!detail.detail.isClosed &&
        detail.detail.modifiedBy === ud.code &&
        !detail.pendingWith.some((item: any) => item.code === ud.code)) ||
      detail.previousLevelReviewers.some((item: any) => item.code === ud.code);

    return (
      showDiv && (
        <div className="alert alert-dismissible alert-warning mt-3">
          This file was last modified on{" "}
          <u>{`${closedOnDt.date} ${closedOnDt.monthName} ${closedOnDt.year}`}</u>{" "}
          <button onClick={this.onRecallFile}>
            Click here to re-call this file
          </button>
        </div>
      )
    );
  };

  onAddComment = async (model: any, attachments: any) => {
    const { detail, showAddCommentLoder } = this.state;
    this.setState({ showAddCommentLoder: true });
    if (
      // detail?.detail?.hasOPTPermission ||
      model?.fileStatus === true
    ) {
      let { mobile } = this.state.ud;
      let OptMOdel = { mobile };

      // First send OTP to mobile
      const otpResponse = await FileSendOpt(OptMOdel);
      if (otpResponse.status === "failed") {
        Swal.fire({
          icon: "error",
          text: otpResponse?.error,
        });
        return;
      }

      // OTP verification loop
      let isOTPVerified = false;
      while (!isOTPVerified) {
        const { value: otp, isDismissed } = await Swal.fire<string>({
          title: "OTP Verification",
          html: `
                          <div style="text-align: center;">
                            <p style="font-size: 16px; color: #444; padding:0px 40px 8px; text-align:center">Enter the OTP sent to your mobile number:</p>
                            <input
                              id="otp-input"
                              class="swal2-input"
                              placeholder="Enter OTP"
                              type="number"
                              maxlength="6"
                              style="width: 80%; margin: 10px auto; letter-spacing: 2px; font-size: 20px;"
                              oninput="this.value = this.value.replace(/[^0-9]/g, '').slice(0, 6)"
                            />
                            <button class="badge badge-light text-primary text-decoration-none" id='resend-otp-btn'>
                              Sending...
                            </button>
                          </div>
                        `,
          icon: "info",
          color: "#444",
          focusConfirm: false,
          showCancelButton: true,
          confirmButtonText: "Verify",
          cancelButtonText: "Cancel",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          allowOutsideClick: false,
          allowEscapeKey: false,
          background:
            "linear-gradient(45deg, #aed6ff 8%, #fafcff 50%, #bcdcff 100%)",
          preConfirm: () => {
            const otpInput = document.getElementById(
              "otp-input"
            ) as HTMLInputElement;
            const otp = otpInput.value.trim();

            if (!otp) {
              Swal.showValidationMessage("Please enter OTP");
              return false;
            }
            if (otp.length !== 6) {
              Swal.showValidationMessage("OTP must be 6 digits");
              return false;
            }
            return otp;
          },
          didOpen: () => {
            const input = document.getElementById(
              "otp-input"
            ) as HTMLInputElement;
            input.focus();
            const resendBtn = document.getElementById("resend-otp-btn");
            if (resendBtn != null) {
              let countdown = 60;
              const countdownInterval = setInterval(() => {
                countdown--;
                resendBtn.setAttribute("disabled", "true");
                resendBtn.textContent = `Resend OTP in ${countdown}s`;

                if (countdown <= 0) {
                  clearInterval(countdownInterval);
                  resendBtn.removeAttribute("disabled");
                  resendBtn.textContent = "Resend OTP";
                }
              }, 1000);
            }
            resendBtn?.addEventListener("click", async () => {
              // Disable button to prevent spam
              resendBtn.setAttribute("disabled", "true");
              resendBtn.textContent = "Resending...";

              try {
                // 🔁 Call your resend OTP function here
                await FileSendOpt(OptMOdel); // <-- Replace this with your actual resend function
                resendBtn.textContent = "OTP Resent ✔️";
              } catch (error) {
                resendBtn.textContent = "Failed. Try Again";
                console.error("Resend OTP error:", error);
              }

              let countdown = 60;
              const countdownInterval = setInterval(() => {
                countdown--;
                resendBtn.textContent = `Resend OTP in ${countdown}s`;

                if (countdown <= 0) {
                  clearInterval(countdownInterval);
                  resendBtn.removeAttribute("disabled");
                  resendBtn.textContent = "Resend OTP";
                }
              }, 1000);

              // Re-enable after 30 seconds or so
              // setTimeout(() => {
              //   resendBtn.removeAttribute("disabled");
              //   resendBtn.textContent = "Resend OTP";
              // }, 30000);
            });
          },
        });

        // User clicked Cancel
        if (isDismissed) {
          this.setState({ showLoader: false, showAddCommentLoder: false });
          return;
        }

        // User clicked Verify and entered valid OTP
        if (otp) {
          this.setState({ showLoader: true });

          try {
            const verifyOptmOdel = {
              mobile,
              mob_otp: otp,
            };

            const verificationResult = await fileOtpVerify(verifyOptmOdel);

            if (verificationResult.status === "success") {
              // await Swal.fire({
              //   title: "Success!",
              //   text: "OTP verified successfully!",
              //   icon: "success",
              //   confirmButtonColor: "#3085d6",
              // });
              setCookie(CONSTANT.cookie.token, verificationResult.result.token);
              setCookie(
                CONSTANT.cookie.userDetail,
                verificationResult.result.userDetail
              );
              isOTPVerified = true;
              addComment(model).then(async (res: any) => {
                this.setState({
                  showLoader: false,
                  showAddCommentLoder: false,
                });
                if (res) {
                  if (res.status === CONSTANT.static.apiStatus.success) {
                    for (let i = 0; i < attachments.length; i++) {
                      const item = attachments[i];
                      const itemModel = {
                        fileCode: res.result.fileCode,
                        commentCode: res.result.code,
                        attachment: item,
                      };
                      await uploadAttachment(itemModel);
                    }
                    this.props.history.push(
                      CONSTANT.component.userFileList.url
                    );
                  } else {
                    alert(res.error);
                  }
                }
              });
            } else {
              await Swal.fire({
                title: "Error!",
                text:
                  verificationResult.error || "Invalid OTP. Please try again.",
                icon: "error",
                confirmButtonColor: "#d33",
              });
              this.setState({ showLoader: false, showAddCommentLoder: false });
            }
          } catch (error) {
            await Swal.fire({
              title: "Error!",
              text: "Failed to verify OTP. Please try again.",
              icon: "error",
              confirmButtonColor: "#d33",
            });
            this.setState({ showLoader: false, showAddCommentLoder: false });
          }
        }
      }
    } else {
      addComment(model).then(async (res: any) => {
        this.setState({ showLoader: false });
        if (res) {
          if (res.status === CONSTANT.static.apiStatus.success) {
            for (let i = 0; i < attachments.length; i++) {
              const item = attachments[i];
              const itemModel = {
                fileCode: res.result.fileCode,
                commentCode: res.result.code,
                attachment: item,
              };
              await uploadAttachment(itemModel);
            }
            this.props.history.push(CONSTANT.component.userFileList.url);
          } else {
            alert(res.error);
          }
        }
      });
    }
  };

  onFileReOpen = (e: any) => {
    this.setState({ showLoader: true });
    const { code } = this.state;
    reOpenFile({ code }).then((res: any) => {
      this.setState({ showLoader: false });
      if (res) {
        if (res.status === CONSTANT.static.apiStatus.success) {
          this.props.history.push(CONSTANT.component.userFileList.url);
        } else {
          alert(res.error);
        }
      }
    });
  };

  onRecallFile = (e: any) => {
    this.setState({ showLoader: true });
    const { code } = this.state;
    reCallFile({ code }).then((res: any) => {
      this.setState({ showLoader: false });
      if (res) {
        if (res.status === CONSTANT.static.apiStatus.success) {
          toast.success("File Recalled Successfully");
          this.props.history.push(CONSTANT.component.userFileList.url);
        } else {
          alert(res.error);
        }
      }
    });
  };

 onPrint = () => {
    // ✅ Capture main content
    const mainSectionElement = document.querySelector(".main-file") as HTMLElement;
    let html = "";
    
    if (mainSectionElement) {
      const clonedSection = mainSectionElement.cloneNode(true) as HTMLElement;
      
      // ✅ Remove 'no-print' class from cloned sections so they appear in print
      const noPrintElements = clonedSection.querySelectorAll('.no-print');
      noPrintElements.forEach(el => {
        el.classList.remove('no-print');
      });
      
      html = clonedSection.innerHTML;
    }

    const additional_info = $(".additional_info").html();
    const commentSection = $(".comment-file");

    // Capture comments
    for (let i = 0; i < commentSection.length; i++) {
      html = html + commentSection[i].innerHTML;
    }

    const style = `
        <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css" integrity="sha384-Vkoo8x4CGsO3+Hhxv8T/Q5PaXtkKtu6ug5TOeNV6gBiFeWPGFN9MuhOf23Q9Ifjh" crossorigin="anonymous">
        <style type="text/css">
        *{box-sizing: border-box; margin:0px; padding:0px;}
        .print-logo-wrapper {
            padding: 20px; margin:20px 0px;
            border: 1px solid #ccc;
            text-align: left;
            position: relative;
            max-width:100%;
        }

        .print-logo-wrapper > img{position: fixed; margin: 0 auto; opacity: 0.4; top: 35%; left: 27%;}
        .print-logo {
            display: block;
            margin: 0 auto;
            z-index: -1;
            position: fixed;
        }

        body, html{
            font-size:16px;
            margin:0px; padding:0px;
            width:100%; height:100%;
            position: relative;
        }

        .card-body{
            border-bottom: 2px dotted gray;
        }

        .footer-print {
            font-size: 12px;
            position: fixed;
            bottom: 0;
            width: 100%;
            text-align: center;
            color: gray;
        }
        
        .print-content {
            margin-bottom: 50px;
        }
        
        .print-watermark {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) rotate(-30deg);
            color: rgba(0, 0, 0, 0.1);
            font-size: 50px;
            font-weight: bold;
            z-index: -1;
            pointer-events: none;
            user-select: none;
            white-space: nowrap;
        }

        /* ✅ Override no-print in the print window */
        .no-print {
          display: block !important;
          visibility: visible !important;
        }

        /* ✅ Force visibility of attachment sections */
        .printFile {
          display: block !important;
          visibility: visible !important;
          opacity: 1 !important;
        }
        
        .card-footer {
          display: block !important;
          visibility: visible !important;
        }

        .badge {
          display: inline-block !important;
          padding: 0.25em 0.6em !important;
          margin: 0.2em !important;
          background-color: #17a2b8 !important;
          color: white !important;
          border-radius: 0.25rem !important;
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
        }
        
        a {
          color: #007bff !important;
          text-decoration: underline !important;
        }

        @page {
            size: A4;
            margin-top: 2cm;
            margin-bottom: 3cm;
            margin-left: 1.5cm;
            margin-right: 1.5cm;
            
            @bottom-center {
                content: element(footer);
            }
        }
        
        #footer {
            position: running(footer);
        }

        @media print {
          /* ✅ In actual print, hide buttons but show content */
          .print-btn {
            display: none !important;
          }
          
          .no-print {
            display: block !important;
          }
          
          .print-logo {
            display: block;
            margin: 0 auto;
            z-index: -1;
            position: fixed;
          }
          body {
            font-size:19.5pt;
          }
          .print-watermark {
            display: block;
          }
          .footer-print {
            display: block;
          }
          .page-break {
            page-break-after: always;
          }
          
          .badge {
            background-color: #17a2b8 !important;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
          
          .printFile, .card-footer {
            display: block !important;
            visibility: visible !important;
          }
        }
        </style>`;

    let myWindow: any = window.open("", "", "width=800,height=600");
    const userName = this.state.ud?.name;
    const employeeNumber = this.state.ud?.employeeNumber;
    const fileCode = this.state.detail?.detail?.code;
    const currentDateTime = new Date().toLocaleString();
    const printedBy = `Printed by: ${userName} | Emp Code: ${employeeNumber} | Timestamp: ${currentDateTime} | Comp. No.:${fileCode}`;

    myWindow.document.write(`${style}
        <button class="print-btn float-right" onclick="window.print()" style="z-index:9999; position:relative;">Print Now</button>
        <div class="fluid-container print-logo-wrapper">
            <img src="./../elogo.png" alt="Logo" class="print-logo" style="position: fixed" />
            <div class="print-content">
                ${html}<br/>
                ${additional_info || ""} <br/>
            </div>
            <div id="footer" class="footer-print text-center">
                ${printedBy}
            </div>
            <button class="print-btn float-right" onclick="window.print()">Print Now</button>
        </div>
    `);

    myWindow.document.close();
    myWindow.focus();
};

  handlePrintLog = async () => {
    let { ud, printReason, otherPrintReason } = this.state;
    const { detail } = this.state;
    if (!printReason.trim()) {
      toast.error("Please select a print reason before proceeding.");
      return;
    }
    if (printReason === "OTHER") {
      if (!otherPrintReason.trim()) {
        toast.error(
          "Please enter a print reason before proceeding in case of other."
        );
        return;
      } else {
        printReason = otherPrintReason;
      }
    }

    const printData = {
      employeecode: ud?.employeeNumber,
      filecode: detail?.detail?.code,
      print_reason: printReason,
      authorityperson:
        detail.approvers.length > 0
          ? detail.approvers[0].employeeNumber
          : ud?.employeeNumber,
    };

    try {
      const res = await createPrintLog(printData);
      if (res?.status == CONSTANT.static.apiStatus.success) {
        this.onPrint();
        // this.setState({ printReason: "" });
        this.closeModal();
      } else {
        toast.error(res.error);
      }
    } catch (error) {
      console.error("Error sending print log:", error);
    }
  };

  toggleAddComment = () => {
    this.setState({ showAddComment: true });
    // window.scrollTo({
    //   top: document.documentElement.scrollHeight, // Total height of the page
    //   behavior: "smooth", // Smooth scrolling
    // });
    window.scrollTo(0, document.body.scrollHeight);
  };
  toggleAddComment2 = () => {
    this.setState({ showAddComment: false });
  };
}

export default ComponentName;
